/*! modal.js | v3.3.3 | license Copyright (C) 2019 - 2025 Taichi Matsutaka */
/*
 *
 * @name    : modal.js
 * @content : modal
 * @creation: 2019.10.14
 * @update  : 2025.10.30
 * @version : 3.3.3
 *
 */
(function(global) {[]
	global.modal = function(target,options){
		const _this = this;

		/**************************************************************
		 * defaults options
		************************************************************ */
		this.target = Array.prototype.slice.call( document.querySelectorAll( target ) ,0) ;

		const defaults = {
			mediaQuery    : null,
			type          : 'img',
			bg            : true,
			bgPosition    : 'wrapper', // wapper or modal or inner
			buttonSelector: '.js-mdoal__btn',
			closePosition : 'inner', // navCenter or inner or contents
			closeSelector : null,
			timeout       : 600,
			wrapper       : 'body',
			modalId       : 'modal',

			firstOpen: false,

			modalClasss         : ['js-modal'],
			modalInnerClasss    : ['js-modal__inner'],
			closeClasss         : ['js-modal__close'],
			bgClasss            : ['c-overlay'],
			navigationClasss    : ['js-modal__navigation'],
			navigationPrevClasss: ['js-modal__navigation__prev'],
			navigationNextClasss: ['js-modal__navigation__next'],

			figureClasss : ['js-modal__figure'],
			captionClasss: ['js-modal__caption'],
			imgClasss    : ['js-modal__img'],

			videoClasss: ['js-modal__video'],

			youtubeClasss       : ['js-modal__youtube'],
			youtubeIframeClasss : ['js-modal__youtube__iframe'],
			youtubeCaptionClasss: ['js-modal__youtube__caption'],

			contentsClasss        : ['js-modal__contents'],
			contentSectionSelector: '.js-modal__section',

			closeInnerHTML         : '',
			navigationPrevInnerHTML: '',
			navigationNextInnerHTML: '',

			openClass: 'is-modal-open',

			onOpen : null,
			onClose: null,
		}


		/**************************************************************
		 * options
		************************************************************ */
		for( let option in options){
			defaults[option] = options[option];
		}
		this.options = defaults;


		/**************************************************************
		 * property
		************************************************************ */
		this.onStructures   = [];
		this.onRestructures = [];
		this.onDestroys     = [];
		this.startingFLg    = false;

		this.button    = [];
		this.buttonAll = document.querySelectorAll( this.options['buttonSelector'] );
		this.length    = [];


		for ( let i = 0; i < this.target.length; i++ ) {
			const button   = this.target[i].querySelectorAll( this.options['buttonSelector'] );
			this.button[i] = button;
			this.length[i] = button.length;
		}

		this.activeTarget = null;
		this.activeGroup  = null;
		this.activeButton = null;
		this.activeIndex  = null;

		this.hiddenTimer  = null;


		/**************************************************************
		 * method
		**************************************************************/
		this._settings();
		this._setupToggle();
		this._setupModalHidden();
		this._setupButtonClick();
		this._setupNaviClick();
		this._setupfirstOpen();
		this._starting();
	};
	modal.prototype = {
		_settings: function(){
			const _this = this;


			/**************************************************************
			 * addSettings
			 *
			 * aria 初期値
			 * aria-label または aria-labelledbyはHTMLで直接指定する。
			 * aria-controls、aria-expanded、aria-hiddenはJavaScriptで指定
			**************************************************************/
			const addSettings = function(){
				for (let i = 0; i < _this.button.length; i++) {
					for (let j = 0; j < _this.button[i].length; j++) {
						_this.button[i][j].dataset.group = i;
						_this.button[i][j].dataset.index = j;
					}
				}
				for ( let i = 0; i < _this.buttonAll.length; i++ ) {
					_this.buttonAll[i].setAttribute('aria-controls', _this.options['modalId'] );
					_this.buttonAll[i].setAttribute('aria-expanded','false');
				}
			}

			this.onStructures.push( function(){
				addSettings();
			});
			this.onRestructures.push( function(){
				addSettings();
			});



			/**************************************************************
			 * createElements
			**************************************************************/
			const createElements = function(){
				_this.wrapper     = document.querySelector( _this.options['wrapper'] );
				_this.modal       = document.createElement('div');
				_this.modal_close = '';
				_this.modal_inner = document.createElement('div');
				_this.modal_bg    = document.createElement('div');

				if( _this.options['closePosition'] == 'navCenter' ){
					_this.modal_close = document.createElement('li');
				} else{
					_this.modal_close = document.createElement('div');
				}

				if( _this.options['closeSelector'] != null ){
					_this.closeButton = _this.wrapper.querySelectorAll( _this.options['closeSelector'] );
				} else{
					_this.closeButton = [];
				}


				_this.navigation      = document.createElement('ul');
				_this.navigation_prev = document.createElement('li');
				_this.navigation_next = document.createElement('li');

				_this.figure     = document.createElement('figure');
				_this.img        = document.createElement('img');
				_this.imgCaption = document.createElement('figcaption');

				_this.video = document.createElement('video');

				_this.youtube        = document.createElement('div');
				_this.youtubeIframe  = document.createElement('iframe');
				_this.youtubeCaption = document.createElement('p');

				_this.contents = document.createElement('div');

				_this.activeContents       = null;
				_this.activeContentsParent = null;


				/* ---------- modal class , HTML ---------- */
				_this.modal.setAttribute( 'id' , _this.options['modalId'] );
				_this.modal.setAttribute('aria-hidden','true');

				_this.modal.classList.add( ..._this.options['modalClasss'] );
				_this.modal_inner.classList.add( ..._this.options['modalInnerClasss'] );
				_this.modal_close.classList.add( ..._this.options['closeClasss'] );
				_this.modal_bg.classList.add( ..._this.options['bgClasss'] );

				_this.navigation.classList.add( ..._this.options['navigationClasss'] );
				_this.navigation_prev.classList.add( ..._this.options['navigationPrevClasss'] );
				_this.navigation_next.classList.add( ..._this.options['navigationNextClasss'] );

				_this.modal_close.innerHTML     = _this.options['closeInnerHTML'];
				_this.navigation_prev.innerHTML = _this.options['navigationPrevInnerHTML'];
				_this.navigation_next.innerHTML = _this.options['navigationNextInnerHTML'];


				/* ---------- img ---------- */
				if( _this.options['type'] === 'img' ){
					_this.modal.classList.add('is-type-img');

					_this.figure.classList.add( ..._this.options['figureClasss'] );
					_this.img.classList.add( ..._this.options['imgClasss'] );
					_this.imgCaption.classList.add( ..._this.options['captionClasss'] );

					_this.img.setAttribute('src',"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3C/svg%3E");

					_this.figure.appendChild( _this.img );
					_this.figure.appendChild( _this.imgCaption );
					_this.modal_inner.appendChild( _this.figure );
				} else if( _this.options['type'] === 'video' ){
				/* ---------- video ---------- */
					_this.modal.classList.add('is-type-video');
					_this.video.classList.add( ..._this.options['videoClasss'] );

					_this.video.setAttribute('controls','');
					_this.modal_inner.appendChild( _this.video );
				} else if( _this.options['type'] === 'youtube' ){
				/* ---------- youtube ---------- */
					_this.modal.classList.add('is-type-youtube');

					_this.youtube.classList.add( ..._this.options['youtubeClasss'] );
					_this.youtubeIframe.classList.add( ..._this.options['youtubeIframeClasss'] );
					_this.youtubeCaption.classList.add( ..._this.options['youtubeCaptionClasss'] );

					_this.youtube.appendChild( _this.youtubeIframe );
					_this.youtube.appendChild( _this.youtubeCaption );
					_this.modal_inner.appendChild( _this.youtube );
				} else if( _this.options['type'] === 'contents' ){
				/* ---------- contents ---------- */
					_this.modal.classList.add('is-type-contents');
					_this.contents.classList.add( ..._this.options['contentsClasss'] );

					_this.modal_inner.appendChild( _this.contents );

					const contentSection = document.querySelectorAll(_this.options['contentSectionSelector']);
					for ( let i = 0; i < contentSection.length; i++ ) {
						contentSection[i].dataset.index = i;
					}
				}


				/* ---------- modal append ---------- */
				/* ----- navigation ----- */
				_this.navigation.appendChild( _this.navigation_prev );
				if( _this.options['closePosition'] === 'navCenter' ){
					_this.navigation.appendChild( _this.modal_close );
				}
				_this.navigation.appendChild( _this.navigation_next );

				/* ----- modal ----- */
				_this.modal.appendChild( _this.modal_inner );
				_this.modal_inner.appendChild( _this.navigation );

				if( _this.options['closePosition'] === 'inner' ){
					_this.modal_inner.appendChild( _this.modal_close );
				} else if( _this.options['closePosition'] === 'contents' ){
					_this.contents.appendChild( _this.modal_close );
				}

				_this.wrapper.appendChild( _this.modal );

				/* ----- bg ----- */
				if( _this.options['bg'] === true ){
					if( _this.options['bgPosition'] === 'wrapper' ){
						_this.wrapper.appendChild( _this.modal_bg );
					} else if( _this.options['bgPosition'] === 'modal' ){
						_this.modal.appendChild( _this.modal_bg );
					} else if( _this.options['bgPosition'] === 'inner' ){
						_this.modal_inner.appendChild( _this.modal_bg );
					}
				}
			}

			this.onStructures.push( function(){
				createElements();
			});
			this.onRestructures.push( function(){
				createElements();
			});



			/**************************************************************
			 * removeElements
			**************************************************************/
			const removeElements = function(){
				_this.modal.parentNode.removeChild( _this.modal );
			}

			this.onDestroys.push( function(){
				removeElements();
			});

		},
		_setupToggle: function(){
			const _this = this;

			/**************************************************************
			 * toggleClass
			**************************************************************/
			_this.toggleClass = {
				modalHidden: function(){
					_this.modal.classList.remove('is-visible');
					_this.modal.classList.remove('is-loading');
					_this.modal.classList.remove('is-load');
					_this.modal_bg.classList.remove('is-visible');
					_this.figure.classList.remove('is-visible');
					_this.video.classList.remove('is-visible');
					_this.youtube.classList.remove('is-visible');
					_this.contents.classList.remove('is-visible');
				},
				buttonClick: function( typeTarget ){
					typeTarget.classList.add('is-visible');
					_this.modal.classList.add('is-visible');
					_this.modal.classList.remove('is-loading');
					_this.modal.classList.add('is-load');
				},
				navigationClick: function(){
					_this.modal.classList.add('is-change');
					_this.modal.classList.add('is-loading');
					_this.modal.classList.remove('is-load');
					_this.figure.classList.remove('is-visible');
					_this.video.classList.remove('is-visible');
					_this.youtube.classList.remove('is-visible');
					_this.contents.classList.remove('is-visible');
				},
			};

			/**************************************************************
			 * ariaData
			**************************************************************/
			_this.ariaData = {
				modalVisible: function(){
					_this.modal.setAttribute('aria-hidden','false');
					_this.activeButton.setAttribute('aria-expanded','true');
				},
				modalHidden: function(){
					_this.modal.setAttribute('aria-hidden','true');
					_this.activeButton.setAttribute('aria-expanded','false');
				},
				buttonActive: function(){
					_this.activeButton.setAttribute('aria-expanded','true');
				},
				buttonPassive: function(){
					_this.activeButton.setAttribute('aria-expanded','false');
				},
			}
		},
		setImgSrc: function( target , callback ){
			const _this = this;

			/**************************************************************
			 * setImgSrc
			**************************************************************/
			/* ---------- img ---------- */
			const src   = target.dataset.modal;
			const image = new Image();
			image.src   = src;
			_this.img.setAttribute('src',src);

			/* ---------- caption ---------- */
			const caption = target.dataset.caption;
			_this.imgCaption.innerHTML = caption;

			/* ---------- callback ---------- */
			if( callback && typeof callback === 'function' ){
				image.onload = function(){
					callback();
				}
			}
		},
		setVideoSrc: function( target , callback ){
			const _this = this;

			/**************************************************************
			 * setVideoSrc
			**************************************************************/
			/* ---------- iframe ---------- */
			const src = target.dataset.modal;
			_this.video.setAttribute( 'src' , src );

			let loadCallback = function(){
				callback();

				_this.video.play();

				_this.video.removeEventListener('canplay',loadCallback);
			}

			/* ---------- callback ---------- */
			_this.video.addEventListener('canplay',loadCallback);
		},
		setYoutubeSrc: function( target , callback ){
			const _this = this;

			/**************************************************************
			 * setYoutubeSrc
			**************************************************************/
			/* ---------- iframe ---------- */
			const youtubeId = target.dataset.modal;
			const src = 'https://www.youtube.com/embed/' + youtubeId +'?start=0&amp;rel=0&amp;controls=1&amp;autoplay=1&amp;loop=1&amp;';
			_this.youtubeIframe.setAttribute( 'src' , src );

			/* ---------- caption ---------- */
			const caption_text = target.dataset.caption;
			_this.youtubeCaption.innerHTML = caption_text;

			let loadCallback = function(){
				callback();
				_this.youtubeIframe.removeEventListener('load',loadCallback);
			}

			/* ---------- callback ---------- */
			if( callback && typeof callback === 'function' ){
				_this.youtubeIframe.addEventListener('load',loadCallback);
			}
		},
		setContents: function( target , callback ){
			const _this = this;

			/**************************************************************
			 * setContents
			**************************************************************/
			if( _this.activeContentsParent ){
				_this.activeContentsParent.appendChild( _this.activeContents );
			}


			/* ---------- appendChild ---------- */
			_this.activeContents       = document.querySelector(_this.options['contentSectionSelector'] +'[data-index="'+ _this.activeIndex +'"]');
			_this.activeContentsParent = _this.activeContents.parentNode;
			_this.contents.appendChild( _this.activeContents );

			/* ---------- callback ---------- */
			if( callback && typeof callback === 'function' ){
				callback();
			}
		},
		_setupModalHidden: function(){
			const _this = this;

			/**************************************************************
			 * _setupModalHidden
			**************************************************************/
			const hidden = function(e){
				if (e && e.preventDefault) e.preventDefault();

				if (_this.modal.contains(document.activeElement)) {
					(_this.activeButton || document.body).focus();
				}

				_this.toggleClass.modalHidden();
				_this.ariaData.modalHidden();

				if ( _this.hiddenTimer ) clearTimeout( _this.hiddenTimer );

				_this.hiddenTimer = setTimeout(function(){
					if( _this.img ){
						_this.img.setAttribute('src','');
						_this.img.style.backgroundImage = '';
					}
					if( _this.video ){
						_this.video.setAttribute('src','');
						_this.video.pause();
					}
					if( _this.youtube ){
						_this.youtubeIframe.setAttribute('src','');
					}
					if( _this.activeContentsParent ){
						_this.activeContentsParent.appendChild( _this.activeContents );
					}
				}, _this.options['timeout']);

				/* ---------- searchParams ---------- */
				const url = new URL( window.location.href );
				url.searchParams.delete('modal-id');
				history.replaceState( null , '' , url );

				/* ---------- onClose ---------- */
				if( typeof _this.options['onClose'] === 'function' ){
					_this.options['onClose']();
				}

				document.body.classList.remove( _this.options['openClass'] );
			}

			this.onStructures.push( function(){
				_this.modal_close.addEventListener( 'click' , hidden );
				_this.modal_bg.addEventListener( 'click' , hidden );

				for ( let i = 0; i < _this.closeButton.length; i++ ) {
					_this.closeButton[i].addEventListener( 'click' , hidden );
				}
			});
			this.onRestructures.push( function(){
				_this.modal_close.addEventListener( 'click' , hidden );
				_this.modal_bg.addEventListener( 'click' , hidden );

				for ( let i = 0; i < _this.closeButton.length; i++ ) {
					_this.closeButton[i].addEventListener( 'click' , hidden );
				}
			});

			this.onDestroys.push( function(){
				_this.modal_close.removeEventListener( 'click' , hidden );
				_this.modal_bg.removeEventListener( 'click' , hidden );

				for ( let i = 0; i < _this.closeButton.length; i++ ) {
					_this.closeButton[i].removeEventListener( 'click' , hidden );
				}
			});
		},
		_setupButtonClick: function(){
			const _this = this;

			/**************************************************************
			 * _setupButtonClick
			**************************************************************/
			const onClick = function(){
				event.preventDefault();

				if ( _this.hiddenTimer ){
					clearTimeout( _this.hiddenTimer );
					_this.hiddenTimer = null;
				}

				const group = this.dataset.group;
				const index = this.dataset.index;

				_this.modal.classList.add('is-loading');
				_this.modal_bg.classList.add('is-visible');

				_this.activeTarget = _this.target[group];
				_this.activeGroup  = group;
				_this.activeButton = this;
				_this.activeIndex  = index;

				_this.ariaData.modalVisible();

				/* ----- navigation ----- */
				if( _this.length[group] == 1 ){
					_this.navigation.style.display = 'none';
				} else{
					_this.navigation.style.display = '';
				}

				/* ----- change ----- */
				if( _this.options['type'] === 'img' ){
					/* ----- img ----- */
					_this.setImgSrc( _this.activeButton , function(){
						_this.toggleClass.buttonClick( _this.figure );
					});
				} else if( _this.options['type'] === 'video' ){
					/* ----- video ----- */
					_this.setVideoSrc( _this.activeButton , function(){
						_this.toggleClass.buttonClick( _this.video );
					});
				} else if( _this.options['type'] === 'youtube' ){
					/* ----- youtube ----- */
					_this.setYoutubeSrc( _this.activeButton , function(){
						_this.toggleClass.buttonClick( _this.youtube );
					});
				} else if( _this.options['type'] === 'contents' ){
					/* ----- contents ----- */
					_this.setContents( _this.activeButton , function(){
						_this.toggleClass.buttonClick( _this.contents );
					});
				}

				/* ---------- searchParams ---------- */
				const modalId = _this.activeButton.dataset.modalId;

				if( modalId ){
					const url = new URL( window.location.href );
					url.searchParams.set( 'modal-id' , modalId );
					history.replaceState( null , '' , url );
				}

				/* ---------- onOpen ---------- */
				if( typeof _this.options['onOpen'] === 'function' ){
					_this.options['onOpen']();
				}

				document.body.classList.add( _this.options['openClass'] );
			}

			this.onStructures.push( function(){
				for (let i = 0; i < _this.button.length; i++) {
					for (let j = 0; j < _this.button[i].length; j++) {
						_this.button[i][j].addEventListener( 'click' , onClick );
					}
				}
			});
			this.onRestructures.push( function(){
				for (let i = 0; i < _this.button.length; i++) {
					for (let j = 0; j < _this.button[i].length; j++) {
						_this.button[i][j].addEventListener( 'click' , onClick );
					}
				}
			});
			this.onDestroys.push( function(){
				for (let i = 0; i < _this.button.length; i++) {
					for (let j = 0; j < _this.button[i].length; j++) {
						_this.button[i][j].removeEventListener( 'click' , onClick );
					}
				}
			});
		},
		_setupNaviClick: function(){
			const _this = this;

			/**************************************************************
			 * _setupNaviClick
			**************************************************************/
			/**************************************************************
			 * navigationClickTimeout
			**************************************************************/
			const navigationClickTimeout = function( button ){
				const group = _this.activeGroup;
				const index = button.dataset.index;

				setTimeout(function(){
					_this.activeButton = _this.button[group][_this.activeIndex];

					_this.ariaData.buttonActive();

					if( _this.options['type'] === 'img' ){
						_this.setImgSrc( _this.activeButton , function(){
							_this.figure.classList.add('is-visible');
							_this.modal.classList.remove('is-change');
							_this.modal.classList.remove('is-loading');
							_this.modal.classList.add('is-load');
						});
					} else if( _this.options['type'] === 'video' ){
						_this.setVideoSrc( _this.activeButton , function(){
							_this.video.classList.add('is-visible');
							_this.modal.classList.remove('is-change');
							_this.modal.classList.remove('is-loading');
							_this.modal.classList.add('is-load');
						});
					} else if( _this.options['type'] === 'youtube' ){
						_this.setYoutubeSrc( _this.activeButton , function(){
							_this.youtube.classList.add('is-visible');
							_this.modal.classList.remove('is-change');
							_this.modal.classList.remove('is-loading');
							_this.modal.classList.add('is-load');
						});
					} else if( _this.options['type'] === 'contents' ){
						_this.setContents( _this.activeButton , function(){
							_this.contents.classList.add('is-visible');
							_this.modal.classList.remove('is-change');
							_this.modal.classList.remove('is-loading');
							_this.modal.classList.add('is-load');
						});
					}

					/* ---------- searchParams ---------- */
					const modalId = _this.activeButton.dataset.modalId;

					if( modalId ){
						const url = new URL( window.location.href );
						url.searchParams.set( 'modal-id' , modalId );
						history.replaceState( null , '' , url );
					}

					/* ---------- onOpen ---------- */
					if( typeof _this.options['onOpen'] === 'function' ){
						_this.options['onOpen']();
					}
				},_this.options['timeout']);
			}



			/**************************************************************
			 * navigation_prev
			**************************************************************/
			const onPrevClick = function(){
				const group = _this.activeGroup;

				/* ---------- onClose ---------- */
				if( typeof _this.options['onClose'] === 'function' ){
					_this.options['onClose']();
				}

				_this.toggleClass.navigationClick();
				_this.ariaData.buttonPassive();

				if( _this.activeIndex == 0 ){
					_this.activeIndex = _this.length[group] - 1;
				} else{
					_this.activeIndex--;
				}

				navigationClickTimeout( this );
			}

			this.onStructures.push( function(){
				_this.navigation_prev.addEventListener('click',onPrevClick);
			});
			this.onRestructures.push( function(){
				_this.navigation_prev.addEventListener('click',onPrevClick);
			});
			this.onDestroys.push( function(){
				_this.navigation_prev.removeEventListener('click',onPrevClick);
			});



			/**************************************************************
			 * navigation_next
			**************************************************************/
			const onNextClick = function(){
				const group = _this.activeGroup;

				/* ---------- onClose ---------- */
				if( typeof _this.options['onClose'] === 'function' ){
					_this.options['onClose']();
				}

				_this.toggleClass.navigationClick();
				_this.ariaData.buttonPassive();

				if( _this.activeIndex >= _this.length[group] - 1 ){
					_this.activeIndex = 0;
				} else{
					_this.activeIndex++;
				}

				navigationClickTimeout( this );
			}

			this.onStructures.push( function(){
				_this.navigation_next.addEventListener('click',onNextClick);
			});
			this.onRestructures.push( function(){
				_this.navigation_next.addEventListener('click',onNextClick);
			});
			this.onDestroys.push( function(){
				_this.navigation_next.removeEventListener('click',onNextClick);
			});


		},
		_setupfirstOpen: function(){
			const _this = this;

			/**************************************************************
			 * _setupfirstOpen
			**************************************************************/
			if( _this.options['firstOpen'] === true ){

				const open = () => {
					const url     = new URL( window.location.href );
					const modalId = url.searchParams.get('modal-id');

					if( !modalId ){
						return false;
					}

					const firstTarget = document.querySelector('[data-modal-id="'+ modalId +'"]');
					if ( firstTarget ){
						firstTarget.click();
					}
				}

				this.onStructures.push( function(){
					open();
				});
			}
		},
		_starting: function(){
			const _this = this;

			/**************************************************************
			 * _starting
			 * ブレイクポイントに合わせて発動
			**************************************************************/
			if( _this.options['mediaQuery'] == null ){
				_this.onStructure();
			} else{
				const breakPoint = function(){
					const mediaQuery = window.matchMedia( _this.options['mediaQuery'] );

					function checkBreakPoint( mediaQuery ) {
						if ( mediaQuery.matches ) {
							if( _this.startingFLg == false ){
								_this.onStructure();
							} else{
								_this.onRestructure();
							}
						} else{
							_this.onDestroy();
						}
					}

					mediaQuery.addListener( checkBreakPoint ); // ブレイクポイントの度に
					checkBreakPoint( mediaQuery ); // 初回
				}
				breakPoint();
			}

			_this.startingFLg = true;
		},
		onStructure: function(){
			/**************************************************************
			 * 構築メソッド
			************************************************************ */
			const onStructures = this.onStructures;
			for ( let i = 0; i < onStructures.length; i++ ) {
				onStructures[i]();
			}
		},
		onRestructure: function(){
			/**************************************************************
			 * 再構築メソッド
			************************************************************ */
			const onRestructures = this.onRestructures;
			for ( let i = 0; i < onRestructures.length; i++ ) {
				onRestructures[i]();
			}
		},
		onDestroy: function(){
			/**************************************************************
			 * 破壊メソッド
			************************************************************ */
			const onDestroys = this.onDestroys;
			for ( let i = 0; i < onDestroys.length; i++ ) {
				onDestroys[i]();
			}
		},
	};

})(this);
